import { IOnInit, IQService } from "angular";
import { UserProfile } from "../../../application/UserProfile";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  vsServiceName as WorkItemTypeServiceName,
  WorkItemTypeService,
} from "../../workItemTypes/provider";
import { ProcessGroup, ProcessInformation } from "../../model/ProcessGroups";
import {
  ProcessApiResponse,
  ProcessApiResponseState,
  ProcessApiResponseWorkFlowTrigger,
  ProcessApiResponseWorkflowItem,
} from "../../model/ProcessApi";
import { flatMap, forEach } from "lodash";
import { ServiceResponse } from "../../../records/server/query";
import { $confirm } from "../../../../@custom_types/confirm";

export class ProcessDetailViewController implements IOnInit {
  static $inject = [
    "userProfile",
    ServerUtilityName,
    WorkItemTypeServiceName,
    "$confirm",
    "$q",
  ];

  tree!: ProcessApiResponse<any>;
  processInformation!: ProcessInformation;
  processGroup!: ProcessGroup;

  dropdown: any = [];
  selectedValue: string = "";
  step1: any;
  currentStep = 1;
  steps = 1;

  constructor(
    private readonly userProfile: UserProfile,
    private readonly serverUtility: ServerUtility,
    private readonly workItemTypeService: WorkItemTypeService,
    private readonly $confirm: $confirm,
    private readonly $q: IQService
  ) {}

  onClickSubmit(workitem: any) {
    this.serverUtility
      .sendApiRequest<ServiceResponse<ProcessApiResponse<any>>>({
        method: "post",
        url: `api${this.processGroup.Url}/${this.tree.Id}/items/${workitem.WorkItemId}`,
        data: { Value: workitem.Value },
      })
      .then((r) => {
        this.initializeFromServerResponse(r.Result);
        this.tree = r.Result;
      });
  }

  getTemplateUrl(type: string) {
    return this.workItemTypeService.getTemplateUrl(type);
  }

  checkRole(role: string): boolean {
    return role == null || role.trim() == "" || this.userProfile.hasRole(role);
  }

  onclickTrigger(name: string) {
    const trigger = this.getTrigger(name);
    const confirmationPromise = trigger?.ConfirmationText
      ? this.$confirm({ text: trigger.ConfirmationText })
      : this.$q.when();
    confirmationPromise
      .then(() => {
        return this.serverUtility.sendApiRequest<
          ServiceResponse<ProcessApiResponse<any>>
        >({
          method: "post",
          url: `/api${this.processGroup.Url}/${this.tree.Id}/trigger/${name}`,
        });
      })
      .then((r) => {
        this.initializeFromServerResponse(r.Result);
        this.tree = r.Result;
      });
  }

  convertDateProperties(workflowItems: any[]): void {
    workflowItems.forEach((item) => {
      this.convertDateProperty(item);
    });
  }

  convertDateProperty(item: any): void {
    if (item.Type === "Date" && item.Value) {
      const date = new Date(item.Value);
      const timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
      item.Value = new Date(date.getTime() + timezoneOffset);
    }

    if (item.Children) {
      item.Children.forEach((child: any) => {
        this.convertDateProperty(child);
      });
    }
  }

  $onInit(): void {
    var StatesLength = 0;
    this.initializeFromServerResponse(this.tree);

    if (this.tree.States && Array.isArray(this.tree.States)) {
      this.tree.States.forEach(function (state) {
        if (
          Array.isArray(state.WorkflowItems) &&
          state.WorkflowItems.length > 0
        ) {
          StatesLength++;
        }
      });
    }
    this.steps = StatesLength;
  }

  private flattenWorkItems(workflowItems: ProcessApiResponseWorkflowItem[]) {
    const result = [...workflowItems];

    forEach(workflowItems, (item) => {
      result.push(...this.flattenWorkItems(item.Children));
    });

    return result;
  }

  private initializeFromServerResponse(
    processApiResponse: ProcessApiResponse<any>
  ) {
    this.tree = processApiResponse;
    const workflowItems = this.flattenWorkItems(
      flatMap(processApiResponse.States, (state) => state.WorkflowItems)
    );
    this.convertDateProperties(workflowItems);
    const currentState = this.getState(processApiResponse.Status);
    const currentStep =
      currentState === undefined
        ? -1
        : processApiResponse.States.indexOf(currentState ?? {});
    this.currentStep = currentStep + 1;
  }

  private getState(name: string): ProcessApiResponseState | undefined {
    return this.tree.States.find((s) => s.Name === name);
  }

  hasTrigger(name: string): boolean {
    return !!this.getTrigger(name);
  }

  private getTrigger(
    name: string
  ): ProcessApiResponseWorkFlowTrigger | undefined {
    return this.tree.Triggers.find((t) => t.Name === name);
  }
}
